<script>
export default {
  name: "settingSupplierIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.00049 9.33331H8.66716C9.40049 9.33331 10.0005 8.73331 10.0005 7.99998V1.33331H4.00049C3.00049 1.33331 2.12716 1.88664 1.67383 2.69997"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33398 11.3333C1.33398 12.44 2.22732 13.3333 3.33398 13.3333H4.00065C4.00065 12.6 4.60065 12 5.33398 12C6.06732 12 6.66732 12.6 6.66732 13.3333H9.33398C9.33398 12.6 9.93398 12 10.6673 12C11.4007 12 12.0007 12.6 12.0007 13.3333H12.6673C13.774 13.3333 14.6673 12.44 14.6673 11.3333V9.33331H12.6673C12.3007 9.33331 12.0007 9.03331 12.0007 8.66665V6.66665C12.0007 6.29998 12.3007 5.99998 12.6673 5.99998H13.5273L12.3873 4.00665C12.1473 3.59332 11.7073 3.33331 11.2273 3.33331H10.0007V7.99998C10.0007 8.73331 9.40065 9.33331 8.66732 9.33331H8.00065"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6673 14.6667C11.4037 14.6667 12.0007 14.0697 12.0007 13.3333C12.0007 12.597 11.4037 12 10.6673 12C9.93094 12 9.33398 12.597 9.33398 13.3333C9.33398 14.0697 9.93094 14.6667 10.6673 14.6667Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6667 8V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.6667 8Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33398 5.33331H5.33398"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33398 7.33331H4.00065"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33398 9.33331H2.66732"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
